import FJCanvasPool from '../FJCanvasPool';
import FJRenderState from './FJRenderState';
import FJElementsRender from './FJElementsRender';
import FJVideoLayer from './FJVideoLayer';
import FJDomLayer from './FJDomLayer';
class FJExportFrame {
    /**
     * @desc 构造函数
     * @param props
     */
    constructor(props) {
        this._time = props.time;
        this._size = props.size;
        this._videoElement = props.videoElement;
        this._videoDecoder = props.videoDecoder;
        this._subtitle = props.subtitle;
        this._frameCanvas = FJCanvasPool.getCanvas();
        this._frameCanvas.width = this._size.width;
        this._frameCanvas.height = this._size.height;
        this._status = FJRenderState.RENDERING;
        this._errMsg = null;
        this._callback = props.callback;
        this._layers = [];
        this._layers.push(
            new FJVideoLayer({
                videoElement: this._videoElement,
                time: this._time,
                exportSize: this._size,
                callback: err => this._layerCallback(err),
                videoDecoder: this._videoDecoder,
            }),
        );
        if (this._subtitle) {
            const subtitleElement = this._subtitle.getElementToRender(this._time);
            if (subtitleElement) {
                if (!FJElementsRender.isElementRendering(subtitleElement)) {
                    FJElementsRender.startElementRender(
                        subtitleElement,
                        {
                            startTime: subtitleElement.getSubtitleTextDelay(),
                            endTime: subtitleElement.getSubtitleTextDelay() + subtitleElement.getSubtitleTextDuration(),
                        },
                        this._size,
                    );
                }
                this._layers.push(
                    new FJDomLayer({
                        element: subtitleElement,
                        time: this._time - subtitleElement.getSubtitleTextDelay(),
                        exportSize: this._size,
                        callback: err => this._layerCallback(err),
                    }),
                );
            }
        }
    }

    start() {
        this._status = FJRenderState.RENDERING;
        this._layers.forEach(layer => layer.start());

        // 开始渲染
        this._nextDrawLayerIdx = 0; // 下一个渲染的层索引

        this._scheduleDrawLayer();
    }
    _layerCallback(err) {
        if (err) {
            this._error(err);
        } else {
            this._scheduleDrawLayer();
        }
    }

    _scheduleDrawLayer() {
        if (this._status !== FJRenderState.RENDERING) return;
        try {
            while (this._nextDrawLayerIdx < this._layers.length && this._layers[this._nextDrawLayerIdx].canDraw) {
                const layer = this._layers[this._nextDrawLayerIdx];

                try {
                    layer.drawToCanvas(this._frameCanvas);
                } catch (e) {
                    // 渲染出错
                    this._error(e?.message);
                    return;
                }

                if (layer.errMsg) {
                    // 渲染出错
                    this._error(layer.errMsg);
                    break;
                }
                layer.clear();
                this._nextDrawLayerIdx++;

                // 检查结束，或是报错
                this._checkDone() || this._checkError();
            }
        } catch (e) {
            this._error(e?.message);
        }
    }

    _checkDone() {
        if (this._nextDrawLayerIdx >= this._layers.length) {
            // 所有层已渲染完成
            this._done();
            return true;
        }

        return false;
    }

    _checkError() {
        let ret = false;
        // 检查是否有渲染出错的层
        for (let i = this._nextDrawLayerIdx; i < this._layers.length; i++) {
            const layer = this._layers[i];
            if (layer.errMsg) {
                // 渲染出错
                this._error(layer.errMsg);
                ret = true;
                break;
            }
        }

        return ret;
    }

    /**
     * @desc 渲染完成
     * @private
     */
    _done() {
        if (this._status !== FJRenderState.RENDERING) return;

        this._status = FJRenderState.DONE;
        if (this._callback) this._callback();
        this._callback = null;
    }

    /**
     * @desc 渲染出错
     * @param errMsg
     * @private
     */
    _error(errMsg) {
        if (this._status !== FJRenderState.RENDERING) return;

        this._status = FJRenderState.ERROR;
        this._errMsg = errMsg;

        if (this._callback) this._callback(errMsg);
        this._callback = null;
    }

    /**
     * @desc 清空
     */
    clear() {
        if (this._status === FJRenderState.CLEARED) return;

        this._status = FJRenderState.CLEARED;
        // 停止元素渲染
        FJElementsRender.stopElementsAtTime(this._time);

        // 清空分层
        this._layers.forEach(layer => layer.clear());
        this._layers = null;

        // 回收canvas
        if (this._frameCanvas) {
            FJCanvasPool.releaseCanvas(this._frameCanvas);
            this._frameCanvas = null;
        }

        this._callback = null;
        this._videoElement = null;
        this._subtitle = null;
    }

    get status() {
        return this._status;
    }

    get errMsg() {
        return this._errMsg;
    }

    get frameCanvas() {
        return this._frameCanvas;
    }

    get isKeyFrame() {
        return this._isKeyFrame;
    }

    get time() {
        return this._time;
    }
}

export default FJExportFrame;
